import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';
import device from 'utils/device';

const template = styled.div`
 ${({ theme }) => css`
    margin-right: 13px; 
    height: 22px; 
    width: 22px; 

    svg {
      width: 100%;
      height: 100%;
      fill: ${theme?.colour?.secondary}
    }
    @media ${device.laptop} {
      height: 25px; 
      width: 23px; 
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'object', template })